<!-- <mat-chip-listbox style="min-width: 130px">
  <mat-chip-option class="{{ chipClass }}" data-test="transactions-chip-status">
    {{ status }}
    <mat-icon *ngIf="paid">paid</mat-icon>
  </mat-chip-option>
</mat-chip-listbox> -->

<mat-icon matListItemIcon [matTooltip]="status" matTooltipPosition="right"  class="{{ chipClass }} {{ status === 'Completed' ? '' : 'outline' }}">{{ getIcon() }}</mat-icon>